export const THE_INDEX_TITLES_NS = 'theindex-titles'

// WordPress category ids used to pick a post's rendered type (post.vue) and
// to detect real per-post data in a cached listing (post.vue, FeaturedIndex.vue).
export const THE_INDEX_CATEGORY_IDS = {
  EVENTS     : 18,
  ATHLETES   : 330,
  DOCUMENTARY: 103,
} as const
